import { useContext } from "react";
import styles from "./CategoryList.module.css";
import DataContext from "../../../store/data-context";
import icon from "../../../../assets/arrow.png";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

export default function CategoryList({ categories, pageData }) {
  const dataCtx = useContext(DataContext);

  const navigate = useNavigate();

  const navigationHandler = () => {
    /*onClick={() => {
      navigate("/hr/katalozi/kuhinjsko_posude");
    }}*/
  };

  return (
    <main className={styles.main} id="catalogues">
      <div className={styles.title}>{pageData.title}</div>
      <div className={styles.list}>
        {categories.map((category, i) => {
          return (
            <Link
              to={
                (dataCtx.lang.lang === "hr" ? "katalozi/" : "kataloge/") +
                category.acf.lang_url
              }
              className={styles[`cat-container`]}
              key={i}
            >
              <div className={styles[`icon-container`]}>
                <img
                  className={styles[`cat-icon`]}
                  src={(category.acf.Icon && category.acf.Icon.url) || icon}
                  alt="icon"
                />
              </div>
              <div className={styles[`cat-title`]}>{category.post_title}</div>
            </Link>
          );
        })}
      </div>
    </main>
  );
}
